import type { MetaFunction } from '@remix-run/node';

export const meta: MetaFunction = () => {
  return [
    { title: '개인정보처리방침 - 법무법인 휘상' },
    { name: 'description', content: '법무법인 휘상의 개인정보처리방침입니다.' },
  ];
};

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">개인정보처리방침</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8">
            법무법인 휘상(이하 '회사')은 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고
            원활하게 처리할 수 있도록 다음과 같이 개인정보처리방침을 수립·공개합니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            1. 개인정보의 수집 및 이용목적
          </h2>
          <p className="text-gray-600 mb-4">
            회사는 다음의 목적을 위하여 개인정보를 수집 및 이용합니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>법률 서비스 제공 및 계약의 이행</li>
            <li>고객 상담 및 문의 응대</li>
            <li>법률 정보 및 서비스 안내</li>
            <li>서비스 이용에 따른 본인확인</li>
            <li>불법 이용 방지 및 부정 이용 방지</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. 수집하는 개인정보 항목</h2>
          <p className="text-gray-600 mb-4">
            회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>필수항목: 성명, 연락처, 이메일 주소</li>
            <li>선택항목: 주소, 직장명, 직위</li>
            <li>자동수집항목: IP 주소, 쿠키, 서비스 이용 기록</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            3. 개인정보의 보유 및 이용기간
          </h2>
          <p className="text-gray-600 mb-8">
            회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이
            파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이
            관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. 개인정보의 파기</h2>
          <p className="text-gray-600 mb-8">
            회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는
            지체없이 해당 개인정보를 파기합니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. 이용자 권리와 행사방법</h2>
          <p className="text-gray-600 mb-4">이용자는 다음과 같은 권리를 행사할 수 있습니다:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>개인정보 열람요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제요구</li>
            <li>처리정지 요구</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            6. 개인정보의 안전성 확보조치
          </h2>
          <p className="text-gray-600 mb-8">
            회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육</li>
            <li>
              기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보
              등의 암호화
            </li>
            <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            7. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항
          </h2>
          <p className="text-gray-600 mb-8">
            회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로
            불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가
            이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에
            저장됩니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. 개인정보 보호책임자</h2>
          <p className="text-gray-600 mb-8">
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의
            불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <div className="bg-gray-50 p-6 rounded-lg mb-8">
            <p className="text-gray-600">개인정보 보호책임자</p>
            <p className="text-gray-600">성명: 황지환</p>
            <p className="text-gray-600">직책: 변호사</p>
            <p className="text-gray-600">연락처: 02-6959-2170</p>
            <p className="text-gray-600">이메일: hwisang@hwisang.co.kr</p>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. 개인정보처리방침의 변경</h2>
          <p className="text-gray-600 mb-8">
            이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제
            및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
          </p>

          <div className="mt-12 text-right">
            <p className="text-gray-600">시행일자: 2025년 4월 11일</p>
          </div>
        </div>
      </div>
    </div>
  );
}
